module.exports = __webpack_public_path__ + "static/media/header.23902e25.png";